import type { Department, SeniorityLevel } from "@/types";

export const SENIORITY_LEVEL_OPTIONS: { value: SeniorityLevel; label: string }[] = [
    { value: "intern", label: "Intern" },
    { value: "fresher", label: "Fresher" },
    { value: "junior", label: "Junior" },
    { value: "middle", label: "Middle" },
    { value: "senior", label: "Senior" },
    { value: "manager", label: "Manager" },
    { value: "director", label: "Director" },
    { value: "ceo", label: "CEO" },
];

export const DEPARTMENT_OPTIONS: { value: Department; label: string }[] = [
    { value: "ceo", label: "CEO" },
    { value: "product", label: "Product" },
    { value: "engineering", label: "Engineering" },
    { value: "operations", label: "Operations" },
    { value: "accounting", label: "Accounting" },
    { value: "cs", label: "CS" },
    { value: "growth_marketing", label: "Growth & Marketing" },
    { value: "hr", label: "HR" },
    { value: "finance", label: "Finance" },
];
